import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06964f0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pickup-station public-style point-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "express-title-regular" }, "Pickup Station:", -1))
const _hoisted_3 = { class: "pickup-station-card" }
const _hoisted_4 = { class: "pickup-station-top" }
const _hoisted_5 = { class: "pickup-station-bottom" }
const _hoisted_6 = { class: "pickup-msg-title" }
const _hoisted_7 = { class: "pickup-msg-content" }
const _hoisted_8 = { class: "phone" }
const _hoisted_9 = { key: 0 }

import { ref, computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'address-point-list',
  props: {
    pointData: {
        type: Object,
        default: () => []
    },
    pickupCheck:{
        type: Object,
        default: ()=>{}
    },
    phoneCode:{
        type:String,
        default:''
    }
},
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props



const handleRadio=(row:any)=>{
    emit("update", row)
}
let pointCheck= computed(() => {
        return props.pickupCheck.id
      })

return (_ctx: any,_cache: any) => {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.pointData.length)
      ? (_openBlock(), _createBlock(_component_van_radio_group, {
          key: 0,
          modelValue: _unref(pointCheck),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pointCheck) ? (pointCheck).value = $event : pointCheck = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pointData, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_van_radio, {
                    name: item.id,
                    onClick: ($event: any) => (handleRadio(item))
                  }, null, 8, ["name", "onClick"]),
                  _createElementVNode("p", null, _toDisplayString(item.address), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.address_name), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (__props.phoneCode.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "+" + _toDisplayString(__props.phoneCode) + " ", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(item.dlyp_mobile), 1)
                    ]),
                    _createElementVNode("span", null, _toDisplayString(item.dlyp_info_decode ? item.dlyp_info_decode.businessTime : ''), 1)
                  ])
                ])
              ]))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})